import React, { useContext, useState, useEffect } from "react";
import Sidebar from "../sidebar/Sidebar";
import NavBar from "../layout/NavBar";
import ActorInvitation from "./ActorInvitation";
import { AuthContext } from "../../context/AuthContext";
import { API } from "../../api/axios";

const PremiumFeaturePage = ({ children }) => {
  const { userId, token } = useContext(AuthContext);
  const [hasSubscription, setHasSubscription] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      if (!userId || !token) {
        setLoading(false);
        return;
      }

      try {
        const response = await API.get(`/payments/payby-details/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (
          response.data.success &&
          Array.isArray(response.data.result) &&
          response.data.result.length > 0
        ) {
          setHasSubscription(true);
        }
      } catch (error) {
        console.error("Error fetching subscription data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptionStatus();
  }, [userId, token]);

  return (
    <div>
      <NavBar />
      <div className="layout-container">
        <Sidebar />
        {loading ? (
          <p>Loading...</p>
        ) : hasSubscription ? (
          <ActorInvitation />
        ) : (
          <main style={{ flex: 1, padding: "20px" }}>{children}</main>
        )}
      </div>
    </div>
  );
};

export default PremiumFeaturePage;
